import { Name } from 'src/app/shared/models/general.models'

export interface organizationFilter {
	SearchText: string
	paging: {
		pageNumber: number
		pageSize: number
	}
	status: number
	startDate: string | null
	endDate: string | null
	countryId: number | null
	includeActive: boolean | null
	includeInActive: boolean | null
	includeSalon: boolean | null
	includeStore: boolean | null
}

export interface organizationsList {
	id: number
	serviceProviderName: string
	branchTotalCount: number
	logoUrl: string
	country: {
		name: Name
		flagUrl: string
		id: number
	}
	mobileNumber: string
	serviceProviderType: {
		id: number
		name: Name
		isActive: boolean
	}
	date: string
	status: string
	isActive: boolean
	isBranchesInformationCompleted: boolean
	businessName: string
	email: string
}
export class organizationModel {
	id?: number
	firstName?: string
	lastName?: string
	email?: string
	serviceProviderName?: string
	businessName?: string
	country!: {
		name: Name
		flagUrl: string
		id: number
	}
	mobileNumber?: string
	type!: {
		id: number
		name: Name
		isActive: boolean
	}
	date?: string
	status?: string
	isActive?: boolean
	commercialRegisterationUrl?: string | null
	commercialRegistration?: string
	coverUrl?: string
	logoUrl?: string | null
	sliderUrl?: string | null
	maroofNumber?: string
	maroofNumberUrl?: string | null
	hasAppointments?: boolean
}
